import React, { useState, useEffect } from 'react';
import { masterAdminAPI } from '../../services/api';
import toast from 'react-hot-toast';

const PendingApprovals = () => {
  const [schools, setSchools] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchPending();
  }, []);

  const fetchPending = async () => {
    try {
      const res = await masterAdminAPI.getPendingSchools();
      setSchools(res.data);
    } catch (error) {
      toast.error('Failed to load pending schools');
    } finally {
      setLoading(false);
    }
  };

  const handleApprove = async (id) => {
    try {
      await masterAdminAPI.approveSchool(id);
      toast.success('School approved');
      fetchPending();
    } catch (error) {
      toast.error('Approval failed');
    }
  };

  const handleReject = async (id) => {
    try {
      await masterAdminAPI.rejectSchool(id);
      toast.success('School rejected');
      fetchPending();
    } catch (error) {
      toast.error('Rejection failed');
    }
  };

  if (loading) return <div>Loading...</div>;

  return (
    <div>
      <h1 className="text-2xl font-bold mb-6">Pending School Approvals</h1>
      {schools.length === 0 ? (
        <p>No pending schools.</p>
      ) : (
        <table className="min-w-full bg-white rounded-lg shadow">
          <thead>
            <tr className="bg-gray-100">
              <th className="px-4 py-2 text-left">Name</th>
              <th className="px-4 py-2 text-left">Email</th>
              <th className="px-4 py-2 text-left">Reg Code</th>
              <th className="px-4 py-2 text-left">Actions</th>
            </tr>
          </thead>
          <tbody>
            {schools.map((school) => (
              <tr key={school.id} className="border-t">
                <td className="px-4 py-2">{school.name}</td>
                <td className="px-4 py-2">{school.email}</td>
                <td className="px-4 py-2">{school.reg_code}</td>
                <td className="px-4 py-2 space-x-2">
                  <button
                    onClick={() => handleApprove(school.id)}
                    className="bg-green-500 text-white px-3 py-1 rounded hover:bg-green-600"
                  >
                    Approve
                  </button>
                  <button
                    onClick={() => handleReject(school.id)}
                    className="bg-red-500 text-white px-3 py-1 rounded hover:bg-red-600"
                  >
                    Reject
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
};

export default PendingApprovals;